import { Pipe, PipeTransform } from '@angular/core';
import { SmsTriggers } from '@workspace/data-types';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Pipe({
  name: 'smsTriggerDisplay',
})
export class SmsTriggerDisplayPipe implements PipeTransform {
  transform(value: SmsTriggers): string {
    return smsTriggerDisplayTransform(value);
  }
}

export function smsTriggerDisplayTransform(value: SmsTriggers) {
  return CoreNiceLabelUtils.smsTrigger(value);
}
